import React, { useState } from "react";
import { DATA } from "../../data/header-data";
import { Link } from "react-router";
import { motion, AnimatePresence } from "framer-motion";
import { languageData } from "../../data/language-data";
import { useTranslation } from "react-i18next";

const MobileHeader = ({ toggle, setToggle }) => {
  const [openMenu, setOpenMenu] = useState(null); // Track the open dropdown menu

  const handleDropdownToggle = (index) => {
    setOpenMenu(openMenu === index ? null : index); // Open/close menu logic
  };

  // Parent container animation
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1, // Stagger effect
      },
    },
  };

  // Animation for individual list items
  const itemVariants = {
    hidden: { opacity: 0, x: -50 }, // Start off-screen
    visible: { opacity: 1, x: 0 }, // Slide into position
  };


      const { i18n } = useTranslation();
      const currentLang = i18n.language 


  return (
    <div className={`h-full grid grid-cols-11 ${toggle ? "block" : "hidden"}`}>
      <div className="col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20 h-full">
        {/* Motion container */}
        <motion.ul
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="text-genesisBlue"
        >
          {DATA.map((item, index) => (
            <motion.li
              key={index}
              variants={itemVariants} // Apply staggered animation
              className="border-b border-gray-200"
            >
              <Link
                to={item.dropDown ? "" : item.link}
                className="flex justify-between items-center cursor-pointer py-2"
                onClick={() => handleDropdownToggle(index)}
              >
                <span className="text-lg font-medium">{item.title[currentLang]}</span>
                {item.dropDown && (
                  <span className="text-2xl">
                    {openMenu === index ? "−" : "+"}
                  </span>
                )}
              </Link>

              {/** Animate the dropdown menu */}
              <AnimatePresence>
                {item.dropDown && openMenu === index && (
                  <motion.ul
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="space-y-2 pl-4 overflow-hidden"
                  >
                    {item.dropDown.map((subItem, subIndex) => (
                      <li key={subIndex} className="text-sm last:pb-4">
                        <Link
                          to={subItem.link}
                          className="block hover:text-gray-200"
                        >
                          {subItem.title[currentLang]}
                        </Link>
                      </li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>


            </motion.li>
          ))}



        </motion.ul>
        {/* <div className="h-7 w-full  mt-20">

            {
              languageData.map((item,index)=>{
                return(
                  <div className="flex items-center justify-center h-full space-x-1">
                  <img src="/images/language-icons/tr.svg" className="h-full  duration-300 hover:scale-105 cursor-pointer"/>
                  <img src="/images/language-icons/en.svg" className="h-full duration-300 hover:scale-105 cursor-pointer"/>
                  <img src="/images/language-icons/ge.svg" className="h-full duration-300 hover:scale-105 cursor-pointer"/>
                  </div>
                )
              })
            }
          
        </div> */}
      </div>
      
    </div>
  );
};

export default MobileHeader;
